import template from "./entity-business-modal.html";
import "./entity-business-modal.less";
import { EVENT_LOGOUT } from "../../../../../../../constants";
import swal from "sweetalert2";
import { isStringNullishOrEmpty } from "../../../../../../../services/string-service";
import cloneDeep from "clone-deep";

// {
// 	Name: "New Business",
// 	Addresses: [
// 		{
// 			AddressLine1: string; // "123 Main St",
// 			AddressLine2: string; // "Suite 100",
// 			AddressLine3: string; // null,
// 			Locale: string; // "Anytown",
// 			Territory: string; //"CA",
// 			Country: string; // "USA",
// 			PostalCode: string; // 5 digits: "12345",
// 			Type: {
// 				Code: "PHYSICAL"
// 			}
// 		}
// 	],
// 	PhoneNumbers: [
// 		{
// 			Value: string;  // "+1 8005551234",
// 			Type: {
// 				Code: "PRIMARY"
// 			}
// 		}
// 	]
// }

export function controller(appState, loadingService, eventBus, $scope, $logger) {
	const ctrl = this;
	ctrl.states = [
		{ value: "AL", label: "Alabama" },
		{ value: "AK", label: "Alaska" },
		{ value: "AZ", label: "Arizona" },
		{ value: "AR", label: "Arkansas" },
		{ value: "CA", label: "California" },
		{ value: "CO", label: "Colorado" },
		{ value: "CT", label: "Connecticut" },
		{ value: "DE", label: "Delaware" },
		{ value: "FL", label: "Florida" },
		{ value: "GA", label: "Georgia" },
		{ value: "HI", label: "Hawaii" },
		{ value: "ID", label: "Idaho" },
		{ value: "IL", label: "Illinois" },
		{ value: "IN", label: "Indiana" },
		{ value: "IA", label: "Iowa" },
		{ value: "KS", label: "Kansas" },
		{ value: "KY", label: "Kentucky" },
		{ value: "LA", label: "Louisiana" },
		{ value: "ME", label: "Maine" },
		{ value: "MD", label: "Maryland" },
		{ value: "MA", label: "Massachusetts" },
		{ value: "MI", label: "Michigan" },
		{ value: "MN", label: "Minnesota" },
		{ value: "MS", label: "Mississippi" },
		{ value: "MO", label: "Missouri" },
		{ value: "MT", label: "Montana" },
		{ value: "NE", label: "Nebraska" },
		{ value: "NV", label: "Nevada" },
		{ value: "NH", label: "New Hampshire" },
		{ value: "NJ", label: "New Jersey" },
		{ value: "NM", label: "New Mexico" },
		{ value: "NY", label: "New York" },
		{ value: "NC", label: "North Carolina" },
		{ value: "ND", label: "North Dakota" },
		{ value: "OH", label: "Ohio" },
		{ value: "OK", label: "Oklahoma" },
		{ value: "OR", label: "Oregon" },
		{ value: "PA", label: "Pennsylvania" },
		{ value: "RI", label: "Rhode Island" },
		{ value: "SC", label: "South Carolina" },
		{ value: "SD", label: "South Dakota" },
		{ value: "TN", label: "Tennessee" },
		{ value: "TX", label: "Texas" },
		{ value: "UT", label: "Utah" },
		{ value: "VT", label: "Vermont" },
		{ value: "VA", label: "Virginia" },
		{ value: "WA", label: "Washington" },
		{ value: "WV", label: "West Virginia" },
		{ value: "WI", label: "Wisconsin" },
		{ value: "WY", label: "Wyoming" }
	];

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onDestroy = ctrl.cancel;

	ctrl.$onInit = () => {
		ctrl.Business = cloneDeep(ctrl.resolve.business ?? {});
		eventBus.register(EVENT_LOGOUT, () => { ctrl.cancel(); }, $scope);
	};

	ctrl.onOk = async() => {
		const payload = cloneDeep(ctrl.Business);

		if(payload.Addresses !== undefined) {
			payload.Addresses = Object.values(payload.Addresses)
				.filter(a => 
					!isStringNullishOrEmpty(a.AddressLine1)
					|| !isStringNullishOrEmpty(a.AddressLine2)
					|| !isStringNullishOrEmpty(a.Locale)
					|| !isStringNullishOrEmpty(a.Territory)
					|| !isStringNullishOrEmpty(a.PostalCode)
				)
				.map(a => ({
					...a,
					Country: "USA",
					Type: {
						Code: "PHYSICAL"
					}
				}));
		}

		if(payload.PhoneNumbers !== undefined) {
			payload.PhoneNumbers = Object.values(payload.PhoneNumbers)
				.filter(ph => !isStringNullishOrEmpty(ph.Value))
				.map(ph => ({
					...ph,
					Type: {
						Code: "PRIMARY"
					}
				}));
		}

		if(!validate(payload)) {
			return;
		}

		const result = await ctrl.resolve.save(payload);
		ctrl.modalInstance.close(result);
	};

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	function validate(payload) {
		const validationStrings = [];

		if(isStringNullishOrEmpty(payload.Name)) {
			validationStrings.push("Business name is required.");
		}

		if(payload.Addresses?.[0]) {
			const address = payload.Addresses[0];
			const matcher = /^[0-9]{5}(-[0-9]{4})?$/;

			if(isStringNullishOrEmpty(address.AddressLine1)) {
				validationStrings.push("When an address is provided, line 1 of the address must be provided");
			}
			if(isStringNullishOrEmpty(address.Locale)) {
				validationStrings.push("When an address is provided, city must be provided");
			}
			if(isStringNullishOrEmpty(address.Territory)) {
				validationStrings.push("When an address is provided, state must be provided");
			}
			if(isStringNullishOrEmpty(address.PostalCode)) {
				validationStrings.push("When an address is provided, zip code must be provided");
			}
			else if(!matcher.test(address.PostalCode)) {
				validationStrings.push("Zip code is an incorrect format.");
			}
		}

		if(payload.PhoneNumbers?.[0]) {
			const phoneNumber = payload.PhoneNumbers[0].Value;
			const matcher = /^\+1 [0-9]{10}$/;

			if(!matcher.test(phoneNumber)) {
				validationStrings.push("Phone number is an incorrect format.");
			}
		}

		if(validationStrings.length > 0) {
			const errorList = `<ul><li>${validationStrings.join("</li><li>")}</li></ul>`;
			
			swal.fire({
				title: "Missing required fields",
				html: 
					`<p>Please correct the following errors</p>
					${errorList}
					`,
				showCloseButton: true,
				type: "warning"
			});
			
			return false;
		}

		return true;
	}
}

export default angular.module("vesl.components.entity-business-modal", [])
	.component("entityBusinessModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
